import { useMemo } from "react";

interface HighlightingState {
  isValidHighlight: boolean;
  highlightedIndex: number;
  getColumnProps: (index: number) => {
    isHighlighted: boolean;
    isBeforeHighlighted: boolean;
    isAfterHighlighted: boolean;
  };
}

export const useHighlighting = (
  highlightedColumn?: number,
  totalColumns: number = 0
): HighlightingState => {
  return useMemo(() => {
    // Only apply highlighting if highlightedColumn is greater than 0
    const isValidHighlight = highlightedColumn !== undefined &&
      highlightedColumn > 0 &&
      highlightedColumn <= totalColumns;

    const highlightedIndex = isValidHighlight ? highlightedColumn - 1 : -1;

    const getColumnProps = (index: number) => ({
      isHighlighted: isValidHighlight && index === highlightedIndex,
      isBeforeHighlighted: isValidHighlight && index === highlightedIndex - 1,
      isAfterHighlighted: isValidHighlight && index === highlightedIndex + 1,
    });

    return {
      isValidHighlight,
      highlightedIndex,
      getColumnProps,
    };
  }, [highlightedColumn, totalColumns]);
};